/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HomeContent_currentTenant$ref: FragmentReference;
export type HomeContent_currentTenant = {|
  +settings: ?{|
    +customWelcomeContentShow: boolean,
    +customWelcomeContentPsa: string,
  |},
  +$refType: HomeContent_currentTenant$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "HomeContent_currentTenant",
  "type": "TenantType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "settings",
      "storageKey": null,
      "args": null,
      "concreteType": "TenantSettingsType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "customWelcomeContentShow",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "customWelcomeContentPsa",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};

(node/*: any*/).hash = '6340408cb947bf2211f7b5fe02ea0be2';
module.exports = node;
